var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "slick",
        {
          ref: "carousel",
          staticClass: "carousel",
          attrs: { options: _vm.slickOptions }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "arrows d-none d-md-block" }, [
        _c("button", { staticClass: "btn prev", on: { click: _vm.prev } }),
        _vm._v(" "),
        _c("button", { staticClass: "btn next", on: { click: _vm.next } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }